import {Decondo}       from "./coop/decondo";
import {Crm}           from "./crm/crm";
import {Demographics}  from "./demographics/demographics";
import {Eddm}          from "./eddm/eddm";
import {Radius}        from "./radius/radius";
import {Street}        from "./street/street";
import {Upload}        from "./upload/upload";
import {Homeowners} from "./homeowners/homeowners";

export const mailingListTypes = [
    {
        value: "upload",
        service: Upload,
    },
    {
        value: "radius",
        service: Radius,
    },
    {
        value: "street",
        service: Street,
    },
    {
        value: "demographics",
        service: Demographics,
    },
    {
        value: "saturation",
        service: Eddm,
    },
    {
        value: "CRM",
        service: Crm,
    },
    {
        value: "co-op/condo building",
        service: Decondo,
    },
    {
        value: "new homeowners",
        service: Homeowners,
    }
];